import PropTypes from 'prop-types';
import React from 'react';
import MediaQuery from 'react-responsive';

const SIZES = {
  small: '(max-width: 40em)',
  large: '(min-width: 40em)',
};

const Responsive = ({ size, children, component }) => (
  <MediaQuery query={SIZES[size]} component={component}>
    {children}
  </MediaQuery>
);

Responsive.propTypes = {
  size: PropTypes.string.isRequired,
  component: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
};

Responsive.defaultProps = {
  component: null,
};

export default Responsive;
